import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum AVANO_ERROR_NUMBERS {
  UNAUTHORIZED_401 = 'UNAUTHORIZED_401',
  FORBIDDEN_403 = 'FORBIDDEN_403',
  NOTFOUND_404 = 'NOTFOUND_404',
  INTERNAL_SERVER_ERROR_500 = 'INTERNAL_SERVER_ERROR_500'
}

@Component({
  selector: 'avano-error-page',
  templateUrl: './avano-error-page.component.html',
  styleUrls: ['./avano-error-page.component.scss']
})
export class AvanoErrorPageComponent {
  @Input() errorNumber: AVANO_ERROR_NUMBERS;

  @Output() readonly backToLogin = new EventEmitter<any>();
  @Output() readonly backToDashboard = new EventEmitter<any>();

  avanoErrorNumbers: typeof AVANO_ERROR_NUMBERS = AVANO_ERROR_NUMBERS;
}
